'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _config = _interopRequireDefault(require("Shared/config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const types = {
  default: _config.default.logo
};
class Logo extends _react.PureComponent {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: types[props.type || 'default'],
      alt: 'Logo ' + _config.default.front_name,
      title: _config.default.front_name,
      style: {
        ...props.style
      },
      className: props.className
    });
    return output;
  }
}
exports.default = Logo;
